import { call, put } from "redux-saga/effects";
import { deleteItemFailure } from "../actions";
import { deleteItemRequest } from "../api";
import { DeleteItemRequestProps } from "src/modules/modules.type";
import { ListFieldsKeys } from "src/api/config";

export function* deleteDefaultSaga<K extends ListFieldsKeys>(payload: DeleteItemRequestProps<K>) {
  try {
    if (payload) {
      const ID: number[] = yield call(deleteItemRequest, payload);
      return ID;
    }
  } catch (error) {
    console.log(error);
    yield put(deleteItemFailure({ listName: payload.listName, error }));
  }
}
